import { z } from "zod";

/**
 * CentroCustoSecundarioSchema
 */

export const CentroCustoSecundarioSchema = z.object({
  idCentroCusto: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
});

/**
 * CentroCustoSecundarioForm
 */

export type CentroCustoSecundarioForm = z.infer<typeof CentroCustoSecundarioSchema>;